import { Controller } from "@hotwired/stimulus"

// Keep unsaved input when changing modes; only active controls are submitted.
export default class extends Controller {
  static targets = ["decision", "reasoning", "questions", "questionTemplate", "bodyPanel", "bodyLabel"]

  connect() {
    this.nextIndex = Date.now()
    this.refresh()
  }

  refresh() {
    const decision = this.element.querySelector('[name="prompt_mode"]:checked').value === "decision"
    for (const [targets, visible] of [[this.decisionTargets, decision], [this.reasoningTargets, !decision]]) {
      targets.forEach(target => {
        target.hidden = !visible
        if (target.tagName === "FIELDSET") target.disabled = !visible
        else target.querySelectorAll("input, select, textarea").forEach(input => { input.disabled = !visible })
      })
    }
    if (this.lastMode !== decision) {
      this.bodyPanelTarget.open = !decision
      this.bodyLabelTarget.textContent = decision ? "Advanced: input template" : "Body"
      this.lastMode = decision
    }
    this.element.querySelectorAll("[data-decision-question]").forEach(question => {
      const options = question.querySelector("[data-decision-options]")
      options.hidden = question.querySelector("[data-decision-type]").value !== "choice"
      options.disabled = options.hidden || !decision
    })
    const questions = this.questionsTarget.querySelectorAll("[data-decision-question]")
    this.questionsTarget.querySelectorAll('[data-action="prompt-editor#removeQuestion"]').forEach(button => {
      button.disabled = questions.length <= 1
    })
    this.questionsTarget.querySelectorAll("[data-option-list]").forEach(list => {
      list.querySelectorAll('[data-action="prompt-editor#removeOption"]').forEach(button => {
        button.disabled = list.children.length <= 2
      })
    })
    const model = this.element.querySelector('select[name$="default_model"], select[name="prompt[default_model]"]')
    if (model) {
      Array.from(model.options).forEach(option => {
        option.disabled = JSON.parse(this.element.dataset.promptEditorDecisionModels).includes(option.value) !== decision
      })
      if (model.selectedOptions[0]?.disabled) {
        model.value = decision ? this.element.dataset.promptEditorDecisionModel : this.element.dataset.promptEditorReasoningModel
      }
    }
  }

  addQuestion() {
    this.questionsTarget.insertAdjacentHTML("beforeend", this.questionTemplateTarget.innerHTML.replaceAll("QUESTION_INDEX", String(this.nextIndex++)))
    this.refresh()
  }

  removeQuestion(event) {
    if (this.questionsTarget.querySelectorAll("[data-decision-question]").length <= 1) return
    event.currentTarget.closest("[data-decision-question]").parentElement.remove()
    this.refresh()
  }

  addOption(event) {
    const options = event.currentTarget.closest("[data-decision-options]")
    options.querySelector("[data-option-list]").insertAdjacentHTML("beforeend", options.querySelector("template").innerHTML.replaceAll("OPTION_INDEX", String(this.nextIndex++)))
    this.refresh()
  }

  removeOption(event) {
    const options = event.currentTarget.closest("[data-option-list]")
    if (options.children.length <= 2) return
    event.currentTarget.closest("[data-decision-option]").remove()
    this.refresh()
  }
}
